export default {
    state: {
        ssAllCountry: [],
        ssMnDepartment: {},
        mnCities: [],
        ssShipperAddressBook: [],
        ssDepartments: [],
        ssShipper: {
            id: null,
            username: null,
            phone: null,
            first_name: null,
            last_name: null,
            email: null,
            street_1: null,
            street_2: null,
            state: null,
            city: null,
            zip: null,
            country_id: null,
            country_iso2: null,
            anonymous: null,
        },
    },
    mutations: {
        ssSetAllCountry(state, payload) {
            state.ssAllCountry = payload
        },
        ssSetShipperAddressBook(state, payload) {
            state.ssShipperAddressBook = payload
        },
        ssSetMnCities(state, payload) {
            state.mnCities = payload
        },
        ssSetShipper(state, payload) {
            if (payload) {
                Object.keys(state.ssShipper).forEach(key => {
                    if (key in payload)
                        state.ssShipper[key] = payload[key]
                });
            }
        },
        ssClearShipper(state) {
            Object.keys(state.ssShipper).forEach(key => {
                state.ssShipper[key] = null
            });
            state.ssShipperAddressBook = [];
        },
        ssSetShipperCountryIso2(state, payload) {
            state.ssShipper.country_iso2 = payload
        },
        ssSetShipperCountryId(state, payload) {
            state.ssShipper.country_id = payload
        },
        ssSetMnDepartment(state, payload) {
            state.ssMnDepartment = payload
        },
        ssSetDepartments(state, payload) {
            state.ssDepartments = payload
        },
    },
    actions: {
        ssSetAllCountry({commit}, payload) {
            commit('ssSetAllCountry', payload)
        },
        ssSetShipperAddressBook({commit}, payload) {
            commit('ssSetShipperAddressBook', payload)
        },
        ssSetMnCities({commit}, payload) {
            commit('ssSetMnCities', payload)
        },
        ssSetShipper({commit}, payload) {
            commit('ssSetShipper', payload)
        },
        ssClearShipper({commit}) {
            commit('ssClearShipper')
        },
        ssSetShipperCountryIso2({commit}, payload) {
            commit('ssSetShipperCountryIso2', payload)
        },
        ssSetShipperCountryId({commit}, payload) {
            commit('ssSetShipperCountryId', payload)
        },
        ssSetMnDepartment({commit}, payload) {
            commit('ssSetMnDepartment', payload)
        },
        ssSetDepartments({commit}, payload) {
            commit('ssSetDepartments', payload)
        },
    },
    getters: {
        ssGetAllCountry(state) {
            return state.ssAllCountry
        },
        ssGetDepartments(state) {
            return state.ssDepartments
        },
        ssIssetCountries: (state) => state.ssAllCountry.length,
        ssIssetDepartments: (state) => state.ssDepartments.length,

        ssGetCountryByIso2(state) {
            return (countryIso2) => {
                return state.ssAllCountry.find((elem)=> {
                    return elem.iso2 === countryIso2
                })
            }
        },
        ssGetAddressBook(state) {
            return state.ssShipperAddressBook
        },
        ssGetMnCities(state) {
            return state.mnCities
        },
        ssIsSetMnCities(state) {
            return state.mnCities.length
        },
        ssShipper(state) {
            return state.ssShipper
        },
        ssShipperPhone(state) {
            return state.ssShipper.phone
        },
        ssMnDepartment(state) {
            return state.ssMnDepartment
        },
        ssShipperId(state) {
            return state.ssShipper.id || null
        },
    }
}
